import { RegistrationRegister } from '../registration-register.model';
import { RegistrationItem } from '../registration-item.model';
import { RegistrationAttendee } from '../registration-attendee.model';
import { RegistrationModificationOptions } from './registration-modification-options.model';
import { RegistrationCustomRegFieldResponse } from '../registration-custom-reg-field-response.model';
import { EventPromoCode } from '../../../shared/promo-codes/event-promo-code.model';
import { EventCustomRegField } from '../../../shared/custom-reg-fields/event-custom-reg-field.model';
import { SourceEnum } from '../../../../shared/model/source.enum';

export class RegistrationUpsert {
  public EventId: number;
  public RegistrationId: number;
  public Registration: RegistrationRegister;
  public Items: Array<RegistrationItem>;
  public Attendees: Array<RegistrationAttendee>;
  public ModificationOptions: RegistrationModificationOptions;
  public IsEdit: boolean;
  public PromoCodes: Array<EventPromoCode>;
  public DoNotSendNotification: boolean;
  public ItemsChanged: boolean;
  public EditNewItemsAdded: boolean;
  public EditOriginalItemsChanged: boolean;
  public EditTotalAmountChanged: boolean;
  public AvailableCustomFields: Array<EventCustomRegField>;
  public ChangedBy: string = '';
  public Source: SourceEnum;

  public constructor() {
    this.EventId = 0;
    this.RegistrationId = 0;
    this.Registration = new RegistrationRegister();
    this.Items = new Array<RegistrationItem>();
    this.Attendees = new Array<RegistrationAttendee>();
    this.ModificationOptions = new RegistrationModificationOptions();
    this.PromoCodes = new Array<EventPromoCode>();
    this.IsEdit = false;
    this.DoNotSendNotification = false;
    this.ItemsChanged = false;
    this.AvailableCustomFields = new Array<EventCustomRegField>();
    this.EditNewItemsAdded = false;
    this.EditOriginalItemsChanged = false;
    this.EditTotalAmountChanged = false;
    this.Source = SourceEnum.BackOfficeSpa;
  }
}
